import { Injectable } from "@angular/core";
import maplibregl from 'maplibre-gl';
import { GEOSERVER_URL, environment } from "src/environments/environment.prod";

import { AuthService } from 'src/app/shared/services/utils/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  map: maplibregl.Map;

  constructor(private authService: AuthService) { }

  getMap(): maplibregl.Map {
    this.map = new maplibregl.Map({
      container: 'map',
      style: { version: 8, sources: {}, layers: [], glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf' },
      center: [-57.5, -3.8], // [lng, lat]
      zoom: 5,
      minZoom: 4,
      maxZoom: 17,
      attributionControl: false,
      transformRequest: (url, resourceType) => {
        if (url.startsWith(`${GEOSERVER_URL}`)) {
          const headers: any = {};

          if (environment.useBearerToken) {
            const token = this.authService.verifyAuthentication();
            if (token) {
              headers['Authorization'] = `Bearer ${token}`;
            }
            headers['ngrok-skip-browser-warning'] = 'true';
          } else {
            headers['Authorization'] = 'Basic ' + btoa('admin:geoserver');
          }

          return {
            url: url,
            headers: headers
          };
        }
        return { url: url };
      }
    });

    this.map.dragRotate.disable();
    this.map.keyboard.disable();
    this.map.touchZoomRotate.disableRotation();

    return this.map;
  }

  resetMap() {
    this.map.flyTo({ center: [-57.5, -3.8], zoom: 5 });
  }
}
